import React, { Component } from "react";


import Paso1 from "../pinVirtual/Paso1";
import Paso2 from "../pinVirtual/Paso2";
import Paso3 from "../pinVirtual/Paso3";
import Titulo from "../../../generico/TituloPagina";
import StepWizard from "react-step-wizard";

export default class CrearPinVirtual extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.paso1 = React.createRef();
    this.paso2 = React.createRef();
    this.paso3 = React.createRef();
  }

  componentDidMount() {
    // let action = sessionStorage.getItem('ACTION');
    // let nroTC = sessionStorage.getItem('numeroTC');
    // this.setState({action:action , numeroTC : nroTC });
  }

  resetState = () => {
    this.setState(this.getInitialState());
  };

  getInitialState = () => ({
    action:undefined,
    numeroTC : undefined,
    buscar: undefined,
    origen:undefined,
  });

  returnDataPaso2(_nroOperacion) {
    this.setState({
      nroOperacion: _nroOperacion,
    });
  }

  returnDataPaso3() {
    this.initDataChildren();
  }
  initDataChildren() {
    this.paso1.current.initData();
    this.paso2.current.resetState();
  }
  onStepChange = (stats) => {
    if (stats.previousStep === 2) {
      
    }
  };

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="Creación/Modificación de PIN" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card" >
                  <div className="card-body" style={{zIndex: 0}}>
                    <StepWizard
                      transitions="none"
                    >
                      <Paso1
                        ref={this.paso1}
                        action={this.state.action}
                        numeroTC={this.state.numeroTC}
                      />
                      <Paso2
                        ref={this.paso2}
                        action={this.state.action}
                      />
                      <Paso3
                        ref={this.paso3}
                      />
                    </StepWizard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
